module.exports = __webpack_public_path__ + "img/event_pc_tab_01.9def53c2.png";